import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const GeneralSearch = (props) => (<Svg viewBox="0 0 24 24" accessibilityRole="image" {...props}>
    <Path d="M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm10 2-4.35-4.35" stroke={props.color || '#393360'} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
export default GeneralSearch;
